import {
    ExpandOutlined,
    FullscreenExitOutlined,
    MoonOutlined,
    QuestionCircleOutlined,
    SunOutlined
} from '@ant-design/icons';
import {SelectLang as UmiSelectLang, useModel, history} from '@umijs/max';
import {useState} from "react";
import {Input} from 'antd';
import styles from './index.less';

export const SelectLang: React.FC = () => {
    return (
        <UmiSelectLang
            style={{
                padding: 4,
            }}
        />
    );
};

export const Question: React.FC = () => {
    return (
        <a
            href="https://pro.ant.design/docs/getting-started"
            target="_blank"
            rel="noreferrer"
            style={{
                display: 'inline-flex',
                padding: '4px',
                fontSize: '18px',
                color: 'inherit',
            }}
        >
            <QuestionCircleOutlined/>
        </a>
    );
};

export const FullScreen = () => {
    const [fullscreen, setFullscreen] = useState(false);

    const toggleFullScreen = () => {
        const element = document.documentElement;
        setFullscreen(!fullscreen);
        if (!document.fullscreenElement) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                // Firefox
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                // Chrome, Safari and Opera
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                // IE/Edge
                element.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                // Chrome, Safari and Opera
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                // IE/Edge
                document.msExitFullscreen();
            }
        }
    };

    return (
        <a className={styles.wrapper} onClick={toggleFullScreen}>
            {fullscreen ? <FullscreenExitOutlined/> : <ExpandOutlined style={{fontSize: 16}}/>}
        </a>
    )
};

export const SearchInput = () => {

    return (
        <Input.Search
            placeholder="请输入文件名称"
            onSearch={(e) => {
                history.push(`/search?name=${e}`)
            }}
        />
    );
};

export const Theme = () => {
    const settings = JSON.parse(localStorage.getItem("settings") || "{}");
    const navTheme = settings.navTheme || 'light';
    const {setInitialState} = useModel('@@initialState');
    const toggleTheme = () => {
        settings.navTheme = navTheme === 'realDark' ? 'light' : 'realDark';
        localStorage.setItem("settings", JSON.stringify(settings));
        setInitialState((s: any) => ({
            ...s,
            settings: {
                ...s?.settings,
                navTheme: settings.navTheme,
            },
        }));
    };

    return (
        <a className={styles.wrapper}
           onClick={toggleTheme}>
            {navTheme === 'light' ? <MoonOutlined/> : <SunOutlined/>}
        </a>
    );
};


export const Download: React.FC = () => {
    return (
        <a
            onClick={() => {
                history.push('/download')
            }}
            className={styles.wrapper}
            style={{
                display: 'inline-flex',
                fontSize: '14px',
                color: 'inherit',
            }}
        >
            <span style={{height: '36px', lineHeight: '36px'}}>下载中心</span>
        </a>
    );
};
